import PropTypes from 'prop-types'
import useError from '../hooks/useError'

const Error = (props) => {
  const { className, name, errores, ...rest } = props
  const { ShowError, hayError } = useError(errores, name)

  const obtenerClases = () => {
    const classes = []
    if (className) {
      classes.push(className)
    }
    if (hayError) {
      classes.push('error')
    }
    return classes.join(' ')
  }

  return (
    <>
      <div {...rest} name={name} className={obtenerClases()}>
        <div>{props.children}</div>
      </div>
      <ShowError />
    </>
  )
}

Error.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  errores: PropTypes.object,
  children: PropTypes.node
}

export default Error
